"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _icons = require("@chakra-ui/icons");

var _layout = require("@chakra-ui/layout");

var _react = require("@chakra-ui/react");

var _FaFolderPlus = require("@react-icons/all-files/fa/FaFolderPlus");

var _FaTh = require("@react-icons/all-files/fa/FaTh");

var _FaThList = require("@react-icons/all-files/fa/FaThList");

var _reactDnd = require("react-dnd");

var _reactDndHtml5Backend = require("react-dnd-html5-backend");

var _UploadButton = _interopRequireDefault(require("../../atoms/UploadButton"));

var _DnDBcrmbItem = _interopRequireDefault(require("./DnDBcrmbItem"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Toolbar = function Toolbar(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactDnd.DndProvider, {
    backend: _reactDndHtml5Backend.HTML5Backend,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
      maxW: "100%",
      p: 2,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Flex, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.ButtonGroup, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_UploadButton["default"], {
            onUpload: props.onUpload
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
            "aria-label": "",
            onClick: props.onNewFolder,
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaFolderPlus.FaFolderPlus, {})
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_layout.Box, {
          ml: 5,
          p: 2,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Breadcrumb, {
            spacing: "8px",
            separator: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ChevronRightIcon, {
              color: "gray.500"
            }),
            children: props.breadcrumbs.map(function (_ref, key) {
              var index = _ref.index,
                  text = _ref.text;
              var isCurrentPage = props.breadcrumbs.length - 1 === key;
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.BreadcrumbItem, {
                isCurrentPage: isCurrentPage,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DnDBcrmbItem["default"], {
                  index: index,
                  onClick: props.onBreadcrumbClick,
                  onDnd: props.onBreadcrumbDnDMove,
                  children: text
                })
              }, key);
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Spacer, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layout.Box, {
          children: [props.view === 'GRID' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
            bg: "transparent",
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaThList.FaThList, {}),
            "aria-label": ""
          }), props.view === 'LIST' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
            bg: "transparent",
            disabled: true,
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FaTh.FaTh, {}),
            "aria-label": ""
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.IconButton, {
            bg: "transparent",
            icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.InfoIcon, {}),
            "aria-label": "",
            onClick: props.onInfoToggleClick
          })]
        })]
      })
    })
  });
};

var _default = Toolbar;
exports["default"] = _default;